import React, { useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ActionToggle from 'live/components/ui/action-toggle'
import ConfigModal from './components/ConfigModal'
import { Row } from 'antd'
import MultipleSelection from './components/MultipleSelection'
import { Layers } from './app'

interface ConfigProps {
    config: {
        showTabs: boolean
        showTotal: boolean
        layers: Layers
    }
    onChange(key: string, value: any): void
}

function ConfigWidget({
    config,
    onChange,
     redux,
    ...props
}: ConfigProps) {
    const [showModal, setShowModal] = useState(false)
    const { showTabs, showTotal, layers } = config
    
    return (
      <div>
        <button
          onClick={() => setShowModal(!showModal)}
          className="btn btn-edit has-icon fixed-size"
        >
          <i className="fas fa-layer-group" />
          <span className="btn-label label-bold">{"CONFIGURAÇÃO DE ABAS"}</span>
          <i className="fa fa-pencil" />
        </button>

        <DivShowTabs>
          <ActionToggle
            onChange={() => {
              onChange("showTabs", !showTabs);
            }}
            active={showTabs}
          />
          {`Show tabs`}
        </DivShowTabs>

        <ConfigModal
          showModal={showModal}
          onChangeConfig={(layers) => onChange("layers", layers)}
          title={"Options"}
          layers={layers}
          hide={() => setShowModal(false)}
          redux={redux}
        />
      </div>
    );
}

export default connect((props: any) => {
    return { redux: props }
})(ConfigWidget)

export const DivShowTabs = styled.div`
    margin: 10px;
`
